import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IEnvConfig } from '../model/env-config.model';
import { IIdentityCardFlowOptions } from '../model/identity-card-flow.model';

@Injectable({ providedIn: 'root' })
export class EnvConfigService<EnvConfig extends IEnvConfig = IEnvConfig> {
  private readonly CONFIG_LOCATION = 'assets/config.json';
  private http: HttpClient;
  private configuration$: Observable<EnvConfig>;
  data: EnvConfig = null;

  constructor(handler: HttpBackend, private translate: TranslateService) {
    this.http = new HttpClient(handler); // make sure interceptors are not used
  }

  public load(): Observable<EnvConfig> {
    if (!this.configuration$) {
      this.configuration$ = this.http
        .get<EnvConfig>(`${this.CONFIG_LOCATION}?v=${Date.now()}`) // must not be cached
        .pipe(
          tap((config) => {
            this.data = config;
          }),
          catchError((error) => {
            if (error instanceof HttpErrorResponse) {
              if (error.status === 404) {
                throw new Error(`Config file int ${this.CONFIG_LOCATION} not found.`);
              }
            }
            throw error;
          })
        );
    }
    return this.configuration$;
  }

  getReadable(name: string): string {
    if (!this.data.readable[name]) {
      return undefined;
    }
    if (!this.translate.currentLang) {
      throw new Error(`Current language is not set - cannot fetch readable: ${name}`);
    }
    return (
      this.data.readable[name][this.translate.currentLang] ||
      this.data.readable[name][this.translate.defaultLang || 'cs'] ||
      null
    );
  }
}
